module.exports = __webpack_public_path__ + "media/images/step_04-c877dae835794c4a1e3e096463a4adf0.gif";